var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "slider__container", attrs: { id: "menu-slider" } },
    [
      _c("span", { staticClass: "slider__hint" }, [_vm._v(_vm._s(_vm.hint))]),
      _vm._v(" "),
      _c("v-slider", {
        attrs: {
          step: "1",
          max: _vm.slide_ticks.length - 1,
          ticks: "always",
          "tick-labels": _vm.slide_ticks,
          "hide-details": ""
        },
        model: {
          value: _vm.selected_tick_index,
          callback: function($$v) {
            _vm.selected_tick_index = $$v
          },
          expression: "selected_tick_index"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }